export const MAX_JOB_DESCRIPTION_LENGTH = 255;

/**
 * A job description is valid when it has non-whitespace content and is no longer
 * than MAX_JOB_DESCRIPTION_LENGTH characters. Mirrors the rules enforced in the
 * job-creation form (NewJob.tsx).
 */
export const isValidJobDescription = (description: string): boolean => {
    return description.trim().length > 0 && description.length <= MAX_JOB_DESCRIPTION_LENGTH;
};
